import { localeUpperFirst } from '@celum/core';
import { WidgetType } from '@celum/portals/domain';
import { WidgetInfo } from '@celum/portals/shared';

import { getInternalLinkName } from './lib/components/content-template-widget-editor/content-template-widget-editor.util';
import { ContentTemplateWidgetConfiguration } from './lib/content-template-widget.model';

export const CONTENT_TEMPLATE_WIDGET: WidgetInfo<ContentTemplateWidgetConfiguration> = {
  type: WidgetType.CONTENT_TEMPLATE,
  defaultConfiguration: () => ({ localImageUploadEnabled: false }),
  thumb: 'widget-icon-content-template',
  name: 'EXPERIENCE.PORTAL_DESIGNER.WIDGET.CONTENT_TEMPLATE_WIDGET.NAME',
  description: {},
  widgetComponent: () => import('./lib/content-template-widget.component').then(module => module.ContentTemplateWidgetComponent),
  defaultNameForInternalLink: config => localeUpperFirst(getInternalLinkName(config.title, config.contentTemplateName))
};
